"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var factory_1 = require("../../factory");
function getInstalledPlugins() {
    var plugins = [];
    if (navigator.plugins) {
        for (var i = 0; i < navigator.plugins.length; i++) {
            var plugin = navigator.plugins[i];
            plugins.push([plugin.name, plugin.filename, plugin.description].join("|"));
        }
    }
    return new Promise(function (resolve) {
        resolve({
            'plugins': plugins
        });
    });
}
exports.default = getInstalledPlugins;
(0, factory_1.includeComponent)('plugins', getInstalledPlugins);
//# sourceMappingURL=plugins.js.map